import * as axios from 'axios';
import * as utils from '../shared/service-utils';

import { API } from '../shared/config';

export default {
  methods: {
    async getPoolUsers() {
      try {
        const hdr = await utils.getAuthHeader();
        const response = await axios.get(`${API}/admin/fetch-pool-users`, { headers: hdr });
        const data = this.parseList(response);
        return data;
      } catch (error) {
        console.error(error);
        return [];
      }
    },
    async resetUsersMFAStatus(payload) {
      try {
        const hdr = await utils.getAuthHeader();
        const response = await axios.post(`${API}/admin/update-mfa-status`, payload, { headers: hdr });
        const data = this.parseSingletonResult(response);
        return data;
      } catch (error) {
        console.error(error);
        return {};
      }
    },
    parseList(response) {
      if (response.status !== 200) throw Error(response.message);
      if (!response.data) return [];
      const list = response.data;
      return list;
    },
    parseSingletonResult(response) {
      if (response.status !== 200) throw Error(response.message);
      if (!response.data) return {};
      const rawData = response.data;
      return rawData;
    },
  },
};
